module.exports = __webpack_public_path__ + "static/media/team.9cc68ebe.webp";